import React, { useEffect, useState } from 'react';
import api from '../api';
import './Dashboard.css';

function Dashboard() {
  const [stats, setStats] = useState({ artists: 0, pendingArtists: 0, songs: 0, pendingSongs: 0, news: 0 });

  useEffect(() => {
    const load = async () => {
      try {
        const [artistsRes, songsRes, newsRes] = await Promise.all([
          api.get('/admin-artists'),
          api.get('/songs/admin/all'),
          api.get('/news/admin/all').catch(() => ({ data: [] })),
        ]);
        setStats({
          artists: artistsRes.data.length,
          pendingArtists: artistsRes.data.filter((a) => a.status === 'pending').length,
          songs: songsRes.data.length,
          pendingSongs: songsRes.data.filter((s) => s.status === 'pending').length,
          news: newsRes.data.length,
        });
      } catch (err) {
        console.error(err);
      }
    };
    load();
  }, []);

  return (
    <div>
      <h1 className="page-title">Dashboard</h1>
      <div className="stat-grid">
        <div className="stat-card">
          <div className="stat-value">{stats.artists}</div>
          <div className="stat-label">Total Artis</div>
          {stats.pendingArtists > 0 && <div className="stat-badge">{stats.pendingArtists} pending</div>}
        </div>
        <div className="stat-card">
          <div className="stat-value">{stats.songs}</div>
          <div className="stat-label">Total Lagu</div>
          {stats.pendingSongs > 0 && <div className="stat-badge">{stats.pendingSongs} pending</div>}
        </div>
        <div className="stat-card">
          <div className="stat-value">{stats.news}</div>
          <div className="stat-label">Berita Diterbitkan</div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
